// ============================================================================
// KAHN'S ALGORITHM - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'kahns',
  name: 'Kahn\'s Algorithm',
  category: 'Graphs',
  complexity: {
    time: 'O(V + E)',
    space: 'O(V)'
  },
  description: 'A topological sorting algorithm that uses BFS and in-degree counting. It repeatedly removes vertices with zero in-degree and their outgoing edges, producing a linear ordering of vertices in a DAG.'
};
